import { logError } from '@/features/shared/utils/logger'
import { isOnServer } from '@shared/constants/util'

const commitSHA = process.env.NEXT_PUBLIC_COMMIT_SHA || ''

const getGatewayRegion = () => {
  switch (process.env.DEPLOY_REGION) {
    case 'us-central1':
    case 'local': // running locally, we still need to resolve to a region
      return 'central'
    case 'us-east4':
      return 'east'
    default:
      logError(
        `Unknown DEPLOY_REGION (${process.env.DEPLOY_REGION}), cannot determine gateway region`,
      )
      return ''
  }
}

export const getApiGatewayURL = () => {
  // Ensure this only runs server-side; env var is available to turn off in emergencies
  // Only use internal route when gateway region is present
  if (
    isOnServer() &&
    process.env.SEGWAY_GATEWAY_TUNNEL_ENABLED === 'true' &&
    process.env.NEXT_PUBLIC_SHIPT_API_GATEWAY_URL_INTERNAL_TEMPLATE &&
    getGatewayRegion()
  ) {
    return process.env.NEXT_PUBLIC_SHIPT_API_GATEWAY_URL_INTERNAL_TEMPLATE.replace(
      '{SIMPLE_REGION}',
      getGatewayRegion(),
    )
  }
  // otherwise, use the public gateway URL
  return process.env.NEXT_PUBLIC_SHIPT_API_GATEWAY_URL
}

export const getRequestParams = (storeParams: Record<string, unknown> = {}) => {
  const params: Record<string, string> = {}

  params.segway_version = commitSHA

  for (const key in storeParams) {
    const value = storeParams[key]
    if (value !== null && value !== undefined && typeof value.toString === 'function') {
      params[key] = value.toString()
    }
  }
  return params
}
